import { Link, useLocation } from 'react-router-dom'

// THE DECK IN THE MENU (owner, 2026-10-07, PL-202: "both"): the swipe deck is reachable from the menu as well as from the
// button on the list. One sub-item under Contacts, lit when the deck is the view on screen. The list stays the screen's
// default (DEC-2026-10-07-07); this is the way back to swiping without first opening the list.

export const DECK_ROUTE = '/contacts?view=cards'

export function onDeck(pathname: string, search: string): boolean {
  return pathname === '/contacts' && new URLSearchParams(search).get('view') === 'cards'
}

export function ContactsViewsNav() {
  const { pathname, search } = useLocation()
  const lit = onDeck(pathname, search)
  return (
    <div className="nav-subs" aria-label="Ways to see your contacts">
      <Link to={DECK_ROUTE} className={`nav-sub ${lit ? 'active' : ''}`} title="One person at a time, strongest reason first: right for important, left for not now">
        <i className="nav-gap" />
        <span className="sub-name">Swipe through them</span>
      </Link>
    </div>
  )
}
